module.exports = __webpack_public_path__ + "img/tor_2.25dc3503.jpg";